export const SUPPORTED_CURRENCIES = [
  'USD',
  'HKD',
  'EUR',
  'GBP',
  'JPY',
  'CNY',
  'SGD',
  'AUD',
  'CAD',
] as const;

export type SupportedCurrency = (typeof SUPPORTED_CURRENCIES)[number];

export const CURRENCY_SYMBOLS: Record<SupportedCurrency, string> = {
  USD: '$',
  HKD: 'HK$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  CNY: 'CN¥',
  SGD: 'S$',
  AUD: 'A$',
  CAD: 'C$',
};

